import axios from 'axios'
import {
    MessageBox,
    Message
} from 'element-ui'

// create an axios instance
const service = axios.create({
    // withCredentials: true, // send cookies when cross-domain requests
     baseURL: '/llg',
    //baseURL: 'http://127.0.0.1:8989',
    timeout: 30000 // request timeout

})

// request interceptor
service.interceptors.request.use(
    config => {
        if (localStorage.getItem('token') != undefined) {
            config.headers['token'] = localStorage.getItem('token')
        }
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data
        console.log(res)
        // if the custom code is not 20000, it is judged as an error.
        if (res.code != 10000) {
            Message({
                message: res.msg || 'Error',
                type: 'error',
                duration: 5 * 1000
            })
            // Token过期
            if (res.code == 20001) {
                MessageBox.confirm('登录状态过期，请重新登录！', '请重新登录', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        // 退出登录config.headers['token'] = localStorage.getItem('token')
                        let headers = {
                            token: localStorage.getItem('token')
                        };
                        axios.get('/llg/user/admin/logout/', {
                            headers: headers
                        }).then(res => {
                            console.log('退登', res);
                            localStorage.clear()
                            window.location.reload()
                        }).catch(err => {
                            console.log('退登出错', err);
                        })
                    })
            }
            return Promise.reject(new Error(res.msg || 'Error'))
        } else {
            return res.data
        }
    },
    error => {
        console.log('err' + error) // for debug
        let msg = error.message;
        if (msg == "Network Error") {
            msg = "看到这个提示请尝试如下操作：1.当前无网络，请检查网络 2.系统正在维护，请晚些再试";
        } else if (msg.indexOf("timeout") > -1) {
            msg = "连接超时，请深吸一口气，重试一下";
        } else {
            msg = "请求错误"
        }
        Message({
            message: msg,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service


// WEBPACK FOOTER //
// ./src/common/js/request.js